var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isEmpty } from "lodash";
import { dataCheckerInterval, lastSyncTime, updateSocketConnectTime, } from "src/utils/loggly-method";
import { checkIsEmpty, jsonToUint } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession, setSessionData, } from "src/utils/session-storage";
import { getMarketFeedV4 } from "../apis/dashboard";
import { SOCKET_CONNECTION_FAILED, SOCKET_EVENT, SOCKET_SUBSCRIPTION_METHODS, } from "../utils/constant";
// import { getSocketLogMessage, logMessage } from "../utils/custom-loggly";
// import { remoteConfigData } from "../utils/custom-remote-config";
// import { checkIsEmpty } from "../utils/methods";
const { REACT_APP_ENV, REACT_APP_URL_WEBSOCKET } = process.env;
let socket;
const noOfRetry = 120000;
let count = 0;
let interval;
let socketTimeout;
let connectionStatusInterval;
let dataUpdateInterval;
let socketUrl = undefined;
let isWindowFocused = true;
// let countForHeartBeat = 0;
let isSocketInitLoading = false;
// let dataCheckerInterval: NodeJS.Timeout | undefined;
let heartBeatInterval;
let updateIntervalId = null;
// let heartBeatReceiveInterval: NodeJS.Timeout | undefined;
let lastMsgTime = Date.now();
let lastHeartBeatTime = Date.now();
let heartBeatMsgSent = false;
let countFailureHeartBeat = 0;
const subscriberList = [];
// const heartBeatSubscriberList: SubscriptionMethod[] = [];
let isSocketConnected = false;
let isDataLoading = false;
const scripMap = {};
let socketConnectDuration = 0;
// let lastSyncTime = Date.now();
let lastPublishTime = 0;
const setSocketConnected = (newValue) => {
    isSocketConnected = newValue;
    if (newValue) {
        clearTimeout(socketTimeout);
    }
    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
    //   resetLastSyncTime: isSocketConnected ? "CONNECT" : "DISCONNECT",
    // });
    const duration = updateSocketConnectTime(isSocketConnected);
    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
    //   method: isSocketConnected ? "CONNECT" : "DISCONNECT",
    //   reason: { disconnectedDuration: duration },
    // });
    if (newValue && isWindowFocused) {
        if (!dataCheckerInterval) {
            // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
            //   dataCheckForConnectedSocket: isSocketConnected,
            //   isWindowFocused: isWindowFocused,
            // });
        }
        if (!dataUpdateInterval) {
            // Commented to remove throttling
            dataUpdateInterval = setInterval(() => {
                checkSyncTimeAndDispatchData();
            }, 500);
        }
    }
    else if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        // countForHeartBeat = 0;
    }
};
const checkSyncTimeAndDispatchData = () => {
    // countForHeartBeat++;
    // if (countForHeartBeat == 4) {
    //   countForHeartBeat = 0;
    // if (
    //   isSocketConnected &&
    //   (REACT_APP_ENV == "production" || REACT_APP_ENV == "staging")
    // ) {
    //   socket?.send("Hi this is a heartbeat message");
    // }
    // }
    Object.keys(scripMap).forEach((singleScripKey) => {
        const scripObj = scripMap[singleScripKey];
        if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
            checkAndDispatchSingleMessageAsPerType(scripObj, false);
        }
    });
};
const subscribeToData = (subscriptionMethod, subscriberName
// callBackMethod?: any
) => {
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    const uniqueRequestArray = [];
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        const isNew = addSingleScripSubscriber(subscriberName, singleElement, subscriptionMethod.Method);
        if (isNew) {
            // if (
            //   singleElement.ScripCode == 11536 ||
            //   singleElement.ScripCode == 532540
            // ) {
            //   console.log(isNew, " isNew");
            // }
            uniqueRequestArray.push(singleElement);
        }
        else {
            const scripObj = scripMap[singleElement.Exch + singleElement.ExchType + singleElement.ScripCode];
            // if (
            //   singleElement.ScripCode == 11536 ||
            //   singleElement.ScripCode == 532540
            // ) {
            //   console.log(JSON.stringify(scripObj), " scripObj");
            // }
            if (scripObj.data != undefined) {
                let currentData = undefined;
                if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS) {
                    currentData = scripObj.data.greekFeedData;
                }
                else if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE) {
                    currentData = scripObj.data.marketDepthData;
                }
                else if (subscriptionMethod.Method ==
                    SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3) {
                    currentData = scripObj.data.marketFeedData;
                }
                else if (subscriptionMethod.Method ==
                    SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE) {
                    currentData = scripObj.data.openInterest;
                }
                if (currentData != undefined) {
                    checkAndDispatchSingleMessage(scripObj, currentData, true, subscriptionMethod.Method);
                }
            }
        }
    });
    if (uniqueRequestArray.length > 0) {
        subscriptionMethod.MarketFeedData = uniqueRequestArray;
    }
    else {
        return;
    }
    //TODO comment to remove unsubscribe logic
    // if (isWindowFocused) {
    if (isSocketConnected) {
        sendMessage(subscriptionMethod);
    }
    else {
        getDataFromMarketFeed();
        //console.log(subscriberName,"subscribername");
    }
    // }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            //Just updating it in case there was rerender.Ideally this component itself will not call again
            // subsObj.callback = callBackMethod;
            if (isEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
const unsubscribeDataBySubscriber = (subscriberName, methodName) => {
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey, methodName);
    });
};
const unsubscribeDataByScrip = (subsriberName, marketFeedSingleElement, methodName) => {
    unSubscribeDataByScripKey(subsriberName, getScripKey(marketFeedSingleElement), methodName);
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey, methodName) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        if (checkIsEmpty(methodName)) {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName != subscriberName;
            });
            if (newSubList.length > 0) {
                scripObj.subscribers = newSubList;
            }
            else {
                delete scripMap[singleScripKey];
            }
        }
        else {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName == subscriberName;
            });
            if (newSubList.length > 0) {
                const newMethodList = newSubList[0].method.filter((singleMethod) => {
                    return singleMethod != methodName;
                });
                if (newMethodList.length > 0) {
                    newSubList[0].method = newMethodList;
                }
                else {
                    //Recursive call as we need to remove the subscriber itself
                    unSubscribeDataByScripKey(subscriberName, singleScripKey);
                }
            }
        }
    }
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
// const compareAndGetNewObjectsArray = (newSubList: SocketDataType[], currSubList: SocketDataType[]): SocketDataType[] =>{}
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
const sendMessage = (subscriptionMethod) => {
    if (REACT_APP_ENV === "development") {
        subscriptionMethod.ClientCode = "54311569";
    }
    try {
        if (isSocketConnected) {
            //TESTING REMOVE
            socket === null || socket === void 0 ? void 0 : socket.send(JSON.stringify(subscriptionMethod));
        }
    }
    catch (error) {
        //console.error(error);
    }
};
const sendAllMessage = (localSubscribeList) => {
    localSubscribeList.forEach((singleElement) => {
        sendMessage(singleElement);
    });
};
const updateSocketConnectedStateAndSendData = (val) => {
    if ((socket === null || socket === void 0 ? void 0 : socket.readyState) == WebSocket.OPEN) {
        setSocketConnected(true);
        publishMessage(SOCKET_EVENT.SOCKET_STATUS, { isConnected: true });
        const duration = new Date().getTime() - socketConnectDuration;
        // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
        //   method: SOCKET_CONNECTION_SUCCESS,
        //   reason: {
        //     reason: SOCKET_CONNECTION_SUCCESS,
        //     duration: duration,
        //     isWindowFocused: isWindowFocused,
        //     socketOpenTime: val,
        //   },
        // });
        sendAllMessage(subscriberList);
        connectionStatusInterval = undefined;
        socketConnectDuration = 0;
        // if (!getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING)) {
        sendHeartBeat();
        // }
    }
    else {
        connectionStatusInterval = setTimeout(() => {
            updateSocketConnectedStateAndSendData(val);
        }, 1000);
    }
};
const onSocketOpen = (event) => {
    if (connectionStatusInterval == undefined) {
        const ws = event.currentTarget;
        const duration = new Date().getTime() - socketConnectDuration;
        // socketConnectDuration = new Date().getTime();
        if (ws instanceof WebSocket) {
            updateSocketConnectedStateAndSendData(duration);
        }
        if (interval) {
            clearInterval(interval);
            interval = undefined;
        }
        //if (!getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING)) {
        sendHeartBeat();
        if (updateIntervalId) {
            clearInterval(updateIntervalId);
            updateIntervalId = null;
        }
    }
    //}
};
const getDataFromMarketFeed = () => __awaiter(void 0, void 0, void 0, function* () {
    // isDataLoading = true;
    if (isDataLoading || isSocketConnected || !isWindowFocused) {
        return;
    }
    // if (isDataLoading) {
    //   return;
    // }
    const marketFeedSubscriber = subscriberList.find((singleData) => {
        if (singleData.Method == "MarketFeedV3") {
            return singleData;
        }
    });
    if (!marketFeedSubscriber) {
        return;
    }
    const promises = [];
    const listLength = marketFeedSubscriber.MarketFeedData.length;
    const loopLength = listLength <= 50 ? 1 : listLength / 50 + 1;
    for (let i = 0; i < loopLength * 50; i = i + 50) {
        let endSize = i + 50;
        if (endSize > listLength) {
            endSize = listLength;
        }
        if (i > listLength) {
            break;
        }
        isDataLoading = true;
        const body = {
            MarketFeedData: marketFeedSubscriber.MarketFeedData.slice(i, endSize),
            Count: endSize - i,
            ClientLoginType: 0,
            LastRequestTime: "/Date(0)/",
            RefreshRate: "H",
        };
        //console.log(marketFeedSubscriber,"marketFeedSubscriber");
        if (!isEmpty(body.MarketFeedData))
            promises.push(getMarketFeedV4(body));
    }
    try {
        const resultArray = yield Promise.all(promises);
        resultArray.forEach((singleCallresult) => {
            var _a;
            const finalResult = ((_a = singleCallresult === null || singleCallresult === void 0 ? void 0 : singleCallresult.data) === null || _a === void 0 ? void 0 : _a.Data) || [];
            finalResult.forEach((element) => {
                handleAndDispatchMessage(element);
            });
        });
    }
    catch (err) {
        console.error(err);
    }
    finally {
        isDataLoading = false;
    }
    setTimeout(() => {
        getDataFromMarketFeed();
    }, 30000);
});
const onSocketMessage = (event) => {
    var _a;
    if ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.byteLength) {
        // console.log(event.data.byteLength, "BYTELENGTH");
        lastHeartBeatTime = Date.now();
        // clearInterval(heartBeatReceiveInterval);
        heartBeatMsgSent = false;
        return;
    }
    let message = event.data.length > 1 ? JSON.parse(event.data) : {};
    if (Array.isArray(message)) {
        message = message[0];
    }
    handleAndDispatchMessage(message);
};
const handleAndDispatchMessage = (message) => {
    if (message) {
        if (message.ReqType) {
            publishMessage(SOCKET_EVENT.ORDER_DATA, message);
            return;
        }
        else if (message.PacketIdentifier && (message === null || message === void 0 ? void 0 : message.PacketIdentifier) == "G") {
            message.Exch = message.Exch ? message.Exch : "N";
            message.ExchType = message.ExchType ? message.ExchType : "D";
        }
        else if (message.Exch == undefined) {
            return;
        }
        if (Date.now() - lastSyncTime > 3000) {
            // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
            //   resetLastSyncTime: "DATA_STARTED_COMING",
            // });
            // resetLastSyncTime("DATA_STARTED_COMING");
        }
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            let dataObj;
            if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
                dataObj = scripObj.data;
            }
            else {
                dataObj = {};
                scripObj.data = dataObj;
            }
            let selectedSocketResponseSyncObject;
            let methodName = "";
            if (message.OpenInterest != undefined) {
                lastMsgTime = Date.now();
                methodName = SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE;
                if (dataObj.openInterest == undefined) {
                    dataObj.openInterest = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.openInterest.response = message;
                    dataObj.openInterest.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.openInterest;
            }
            else if (message.Details != undefined) {
                lastMsgTime = Date.now();
                methodName = SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE;
                if (!dataObj.marketDepthData) {
                    dataObj.marketDepthData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketDepthData.response = message;
                    dataObj.marketDepthData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketDepthData;
            }
            else if ((message === null || message === void 0 ? void 0 : message.PacketIdentifier) &&
                (message === null || message === void 0 ? void 0 : message.PacketIdentifier) == "G") {
                methodName = SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS;
                if (!dataObj.greekFeedData) {
                    dataObj.greekFeedData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.greekFeedData.response = message;
                    dataObj.greekFeedData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.greekFeedData;
            }
            else {
                methodName = SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3;
                if (dataObj.marketFeedData == undefined) {
                    dataObj.marketFeedData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketFeedData.response = message;
                    dataObj.marketFeedData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketFeedData;
            }
            // if (!selectedSocketResponseSyncObject.syncTime) {
            //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
            // }
            const isDataSubscribed = checkAnddispatchDataUsingCallBack(scripObj, message, methodName);
            if (isDataSubscribed) {
                if (!isSocketConnected) {
                    dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
                }
                //Commented this to remove throttling completely
                // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
                //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
                // } else
                else if (!selectedSocketResponseSyncObject.syncTime) {
                    dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
                }
            }
            else {
                unsubscribeSpecificMethodFromSocket(message.Exch, message.ExchType, message.Token, methodName);
            }
        }
        else if (isSocketConnected) {
            unsubscribeFromSocket(message.Exch, message.ExchType, message.Token);
        }
    }
};
const checkAnddispatchDataUsingCallBack = (scripObj, message, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        let localSubsribed = false;
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
                localSubsribed = true;
            }
        });
        if (localSubsribed && singleSubscriber.callback) {
            singleSubscriber.callback(message);
        }
    });
    return isDataSubscribed;
};
const checkAndDispatchSingleMessageAsPerType = (scripObj, sendDataAgain) => {
    var _a, _b, _c, _d;
    if ((_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketDepthData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketDepthData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE);
    }
    if ((_b = scripObj.data) === null || _b === void 0 ? void 0 : _b.openInterest) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.openInterest, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE);
    }
    if ((_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.marketFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketFeedData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3);
    }
    if ((_d = scripObj.data) === null || _d === void 0 ? void 0 : _d.greekFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.greekFeedData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS);
    }
};
const checkAndDispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject, sendDataAgain, methodName) => {
    if (!selectedSocketResponseSyncObject.syncTime) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
    }
    else if (selectedSocketResponseSyncObject.syncTime ==
        selectedSocketResponseSyncObject.lastUpdateTime &&
        !sendDataAgain) {
        //DO nothing as latest data is already updated
    }
    //Commented this to remove throttling
    // if (
    // DATA_UI_REFRESHRATE <=
    // selectedSocketResponseSyncObject.lastUpdateTime.getTime() -
    //   selectedSocketResponseSyncObject.syncTime.getTime()
    // )
    else {
        //This is added for testing only
        // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "production")
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
    }
    // else {
    //   //Do nothing as data is already updated within the window. This is the throttled data
    // }
};
const dispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject, methodName) => {
    selectedSocketResponseSyncObject.syncTime =
        selectedSocketResponseSyncObject.lastUpdateTime;
    if (selectedSocketResponseSyncObject.response &&
        selectedSocketResponseSyncObject.response.PacketIdentifier == "G") {
        publishMessage(methodName, selectedSocketResponseSyncObject.response);
    }
    else {
        publishMessage(methodName, selectedSocketResponseSyncObject.response);
    }
};
const unsubscribeFromSocket = (exch, exchType, scripCode) => {
    if (subscriberList.length > 0) {
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "MarketFeedV3");
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "GetScripInfoForFuture");
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "BaseGreeks");
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "MarketDepthService");
    }
};
const unsubscribeSpecificMethodFromSocket = (exch, exchType, scripCode, methodName) => {
    if (subscriberList.length > 0) {
        const method1 = {
            Method: methodName,
            Operation: "UnSubscribe",
            ClientCode: subscriberList[0].ClientCode,
            MarketFeedData: [
                { Exch: exch, ExchType: exchType, ScripCode: scripCode },
            ],
        };
        sendMessage(method1);
    }
};
export const unSubscribeAllData = () => {
    isWindowFocused = false;
    if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        // countForHeartBeat = 0;
    }
    // const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    // if (clientCode && remoteConfigData) {
    //   const isClientCodePresent = remoteConfigData.clientlist.find(
    //     (singleClientCode) => {
    //       return singleClientCode == clientCode;
    //       // return singleClientCode == "57675310";
    //     }
    //   );
    //   if (isClientCodePresent) {
    //     return;
    //   }
    // }
    const cloneData = JSON.parse(JSON.stringify(subscriberList));
    cloneData.forEach((singleSubscription) => {
        singleSubscription.Operation = "UnSubscribe";
    });
    sendAllMessage(cloneData);
};
const onSocketError = (event) => {
    // publishMessage(SOCKET_EVENT.SOCKET_ERROR, event);
    publishMessage(SOCKET_EVENT.SOCKET_ERROR, {
        method: SOCKET_CONNECTION_FAILED,
        reason: {
            reason: "SOCKET_CONNECTION_ERROR",
            error: event,
            isWindowFocused: isWindowFocused,
        },
    });
    // https://stackoverflow.com/questions/40084398/is-onclose-always-called-after-onerror-for-websocket
    // handleClose();
    // console.log("ONERROR SCOKET");
    if (connectionStatusInterval) {
        clearTimeout(connectionStatusInterval);
    }
};
const onSocketClose = () => {
    handleClose();
    if (connectionStatusInterval) {
        clearTimeout(connectionStatusInterval);
    }
    if (!updateIntervalId) {
        updateIntervalId = setInterval(() => {
            // Call updatePositionOrderBook API
            publishMessage(SOCKET_EVENT.CALL_POSITION_DATA, {});
        }, 5000);
    }
};
export function handleClose() {
    publishMessage(SOCKET_EVENT.SOCKET_STATUS, { isConnected: false });
    setSocketConnected(false);
    clearInterval(heartBeatInterval);
    socket = undefined;
    if (isWindowFocused) {
        getDataFromMarketFeed();
    }
    if (interval) {
        return;
    }
    interval = setInterval(() => {
        if (count >= noOfRetry) {
            if (interval)
                clearInterval(interval);
            interval = undefined;
            // console.error("No of retry for connection exceeds");
            return;
        }
        //Call resubscribe only if window is focused and the connection got disconnected.
        //As it will get called anyways when the windows gets the refocus.
        if (isWindowFocused) {
            reSubscribeSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
        }
        else {
            if (interval)
                clearInterval(interval);
        }
        count = count + 1;
    }, 5000);
}
// const closeWebSocket = (): void => {
//   isWindowFocused = false;
//   if (isSocketConnected && socket) {
//     socket.close();
//   }
// };
export const reconnectSocket = (localClientCode) => {
    // if (isSocketConnected) {
    //   return;
    // }
    try {
        if (socket) {
            socket.close();
        }
    }
    catch (error) {
        //onsole.error(error);
    }
    finally {
        socket = undefined;
    }
    reSubscribeSocket(localClientCode);
};
export const reSubscribeSocket = (localClientCode) => {
    // if (isSocketConnected) {
    //   return;
    // }
    isWindowFocused = true;
    try {
        if (socket) {
            if (isSocketConnected) {
                if (!dataUpdateInterval) {
                    //Commented to remove throttling
                    dataUpdateInterval = setInterval(() => {
                        checkSyncTimeAndDispatchData();
                    }, 500);
                }
                sendAllMessage(subscriberList);
                if (!dataCheckerInterval) {
                    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                    //   resetLastSyncTime: "RESUBSCRIBED",
                    // });
                    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                    //   dataCheckForConnectedSocket: isSocketConnected,
                    //   isWindowFocused: isWindowFocused,
                    // });
                }
            }
            else {
                //Socket is trying to connect and will get connected and get subscribed anyway
            }
            // socket.close();
        }
        else if (isSocketInitLoading) {
            // console.log("This is a tribute yoyo");
            //Do nothing as socket init is already called
        }
        else if (socketUrl) {
            //initWebSocket(socketUrl, true);
        }
        else {
            swarajSocketInit(localClientCode, true);
        }
    }
    catch (error) {
        //console.error(error);
    }
};
export const initWebSocket = (wsUrl, localIsWindowFocus) => {
    if (localIsWindowFocus) {
        isWindowFocused = true;
    }
    socketUrl = wsUrl;
    isSocketInitLoading = true;
    return new Promise((resolve, reject) => {
        try {
            if (!wsUrl || !isWindowFocused || isSocketConnected) {
                return;
            }
            socketConnectDuration = new Date().getTime();
            socketUrl = wsUrl;
            socket = new WebSocket(wsUrl);
            socket.onopen = onSocketOpen;
            socket.onmessage = onSocketMessage;
            //socket.onerror = onSocketError;
            socket.onclose = onSocketClose;
            resolve(socket);
            // setTimeout(() => {}, 1000000);
            socketTimeout = setTimeout(() => {
                try {
                    if (isSocketConnected == false) {
                        //BREAK RETRY CONNECTION
                        reconnectSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
                        const currentTime = new Date().getTime();
                        if (currentTime - lastPublishTime >= 10000) {
                            // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                            //   method: SOCKET_CONNECTION_FAILED,
                            //   reason: {
                            //     reason: `${SOCKET_CONNECTION_FAILED}_FORCEFULLY`,
                            //     isWindowFocused: isWindowFocused,
                            //   },
                            // });
                            lastPublishTime = currentTime;
                        }
                    }
                }
                catch (error) {
                    //console.error(error);
                }
            }, 10000);
        }
        catch (err) {
            reject(err);
            // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
            //   method: isSocketConnected ? "CONNECT" : "DISCONNECT",
            //   reason: { disconnectedError: err },
            // });
        }
        finally {
            isSocketInitLoading = false;
        }
    });
};
const swarajSocketInit = (localClientCode, localIsWindowFocus) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const swarajWsurl = REACT_APP_URL_WEBSOCKET +
            `/TTWebSocket/api/chat?Value1=${localClientCode}`;
        //initWebSocket(swarajWsurl, localIsWindowFocus);
        // }
    }
    catch (err) {
        //console.error(err);
    }
    finally {
    }
});
const randomMessageGenerator = (isEven) => {
    let seconds = new Date().getSeconds();
    //This is done so ticker size is 5 paisa only
    if (seconds > 5) {
        seconds = seconds - (seconds % 5);
    }
    else {
        seconds = 0;
    }
    Object.keys(scripMap).forEach((singleKey) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const scripObj = scripMap[singleKey];
        if (scripObj && scripObj.subscribers.length > 0) {
            if ((_b = (_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketFeedData) === null || _b === void 0 ? void 0 : _b.response) {
                const dataToSend = Object.assign({}, (_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.marketFeedData.response);
                // dataToSend.PClose = dataToSend.PClose;
                // dataToSend.LastRate = dataToSend.LastRate + seconds * 10;
                dataToSend.LastRate = dataToSend.LastRate + seconds / 100;
                // if (singleKey.includes("37834")) {
                //   console.log(scripObj, new Date());
                // }
                handleAndDispatchMessage(dataToSend);
            }
            if ((_e = (_d = scripObj.data) === null || _d === void 0 ? void 0 : _d.openInterest) === null || _e === void 0 ? void 0 : _e.response) {
                const dataToSend = Object.assign({}, (_f = scripObj.data) === null || _f === void 0 ? void 0 : _f.openInterest.response);
                dataToSend.OpenInterest = dataToSend.OpenInterest + seconds / 100;
                handleAndDispatchMessage(dataToSend);
            }
            if ((_h = (_g = scripObj.data) === null || _g === void 0 ? void 0 : _g.marketDepthData) === null || _h === void 0 ? void 0 : _h.response) {
                // const dataToSend = { ...scripObj.data?.marketDepthData.response };
                const dataToSend = JSON.parse(JSON.stringify((_j = scripObj.data) === null || _j === void 0 ? void 0 : _j.marketDepthData.response));
                if (dataToSend.Details.length == 0) {
                    dataToSend.Details.push({
                        Quantity: 999,
                        Price: 123,
                        NumberOfOrders: 100,
                        BbBuySellFlag: 66,
                    });
                }
                dataToSend.Details[0].Price =
                    dataToSend.Details[0].Price + seconds / 100;
                dataToSend.Details[0].Quantity =
                    dataToSend.Details[0].Quantity + seconds;
                dataToSend.Details[0].NumberOfOrders =
                    dataToSend.Details[0].NumberOfOrders + seconds;
                handleAndDispatchMessage(dataToSend);
            }
            if (((_l = (_k = scripObj.data) === null || _k === void 0 ? void 0 : _k.greekFeedData) === null || _l === void 0 ? void 0 : _l.response) == undefined) {
                const dataToSend = {
                    PacketIdentifier: "G",
                    MessageLength: 200,
                    Token: Number(singleKey.replace("ND", "")),
                    IV: 0.01 + seconds / 10000,
                    DELTA: 0.02 + seconds / 10000,
                    THETA: 0.03 + seconds / 10000,
                    VEGA: 0.04 + seconds / 10000,
                    GAMMA: 0.05 + seconds / 10000,
                    IV_VWAP: 0.06 + seconds / 10000,
                    VANNA: 0.07 + seconds / 10000,
                    CHARM: 0.08 + seconds / 10000,
                    SPEED: 0.09 + seconds / 10000,
                    ZOMMA: 0.1 + seconds / 10000,
                    COLOR: 0.11 + seconds / 10000,
                    VOLGA: 0.12 + seconds / 10000,
                    VETA: 0.13 + seconds / 10000,
                    TGR: 0.14 + seconds / 10000,
                    TV: 0.15 + seconds / 10000,
                    DTR: 0.16 + seconds / 10000,
                };
                handleAndDispatchMessage(dataToSend);
            }
        }
    });
    setTimeout(() => {
        randomMessageGenerator(isEven);
    }, 1000);
};
if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
    // randomMessageGenerator(true);
}
if (REACT_APP_ENV == "development") {
    // randomMessageGenerator(true);
}
const publishMessage = (eventType, data) => {
    // if (eventType == SOCKET_EVENT.MARKETFEED_DATA && data.Token == "999920000") {
    //   console.log(Date.now(), "This is a tribute to Nifty", data);
    // }
    const output = { eventType: eventType, data: data };
    self.postMessage(jsonToUint(output));
};
self.onmessage = (e) => {
    const inputEvent = e.data;
    try {
        switch (inputEvent.eventType) {
            case SOCKET_EVENT.CONNECT_SOCKET: {
                // clientCode = inputEvent.data.clientCode;
                socketUrl = inputEvent.data.wsUrl;
                const sessionData = inputEvent.data.sessionData;
                // sessionData[SESSION_KEYS.CLIENT_CODE] = clientCode;
                setSessionData(JSON.stringify(sessionData));
                //initWebSocket(socketUrl, true);
                subscribeToData({
                    Method: "MarketFeedV3",
                    Operation: "subscribe",
                    ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
                    MarketFeedData: [
                        {
                            Exch: "N",
                            ExchType: "C",
                            ScripCode: 999920000,
                        },
                    ],
                }, "SELF");
                break;
            }
            case SOCKET_EVENT.SUBSCRIBE:
                subscribeToData(inputEvent.data, inputEvent.data.subscriberName);
                break;
            case SOCKET_EVENT.UNSUBSCRIBE:
                unsubscribeDataByScrip(inputEvent.data.subscriberName, inputEvent.data.scripData, inputEvent.data.methodName);
                // sendMessage(inputEvent.data);
                break;
            case SOCKET_EVENT.UNSUBSCRIBE_BY_SUBSCRIBER:
                unsubscribeDataBySubscriber(inputEvent.data.subscriberName, inputEvent.data.methodName);
                // sendMessage(inputEvent.data);
                break;
            case SOCKET_EVENT.IS_WINDOW_FOCUSED: {
                isWindowFocused = inputEvent.data;
                if (isWindowFocused) {
                    reSubscribeSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE));
                }
                else {
                    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                    //   resetLastSyncTime: "WINDOW_NOT_FOCUSED",
                    // });
                    unSubscribeAllData();
                    // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                    //   method: "SOCKET_DATA_STREAM_STOPPED",
                    //   reason: { reason: "WINDOW_NOT_FOCUSED" },
                    // });
                }
                break;
            }
            default:
                break;
        }
        // self.postMessage({ simpleKey: "Yo yo" });
    }
    catch (error) {
        //console.error(error);
    }
};
//For testing only
// self.onmessage = (e: MessageEvent<any>) => {
//   try {
//     console.log("This is a tribute from serivce worker", e, e.data);
//     clientCode = e.data.clientCode;
//     socketUrl = e.data.wsUrl;
//     const sessionData = {};
//     sessionData[SESSION_KEYS.CLIENT_CODE] = clientCode;
//     try {
//       const sessionClientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
//       console.log(sessionClientCode);
//     } catch (error) {
//       console.error(error);
//     }
//     setSessionData(JSON.stringify(sessionData));
//     initWebSocket(socketUrl, true);
//     subscribeToData(
//       {
//         Method: "MarketFeedV3",
//         Operation: "subscribe",
//         ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
//         MarketFeedData: [
//           {
//             Exch: "N",
//             ExchType: "C",
//             ScripCode: 999920000,
//           },
//         ],
//       },
//       "SELF",
//       () => {}
//     );
//     // reSubscribeDepthSocket(clientCode);
//     self.postMessage({ simpleKey: "Yo yo" });
//   } catch (error) {
//     console.error(error);
//   }
// };
//Send HeartBeat Message In Binary
const sendHeartBeat = () => {
    if (heartBeatInterval) {
        clearTimeout(heartBeatInterval);
        heartBeatInterval = undefined;
    }
    heartBeatInterval = setInterval(() => {
        if (Date.now() - lastMsgTime > 3000 &&
            isSocketConnected &&
            isWindowFocused &&
            !heartBeatMsgSent) {
            const randomNumber = Math.floor(Math.random() * 10);
            if (socket) {
                socket.binaryType = "arraybuffer";
                const x = new Uint8Array([randomNumber]);
                socket === null || socket === void 0 ? void 0 : socket.send(x.buffer);
                // publishMessage(SOCKET_EVENT.LOGGLY_DATA, { method: "SEND HEARTBEAT" });
                //  logHeartBeat('SEND HEARTBEAT', getDataFromSession(SESSION_KEYS.CLIENT_CODE));
                heartBeatMsgSent = true;
                receiveHeartBeat(Date.now());
            }
        }
    }, 3000);
};
const receiveHeartBeat = (HeartBeatSentTime) => {
    // clearInterval(heartBeatReceiveInterval);
    setTimeout(() => {
        if (heartBeatMsgSent && Date.now() - lastHeartBeatTime > 2000) {
            // console.log("WAITING FOR MSG HEARTBEAT");
            if (countFailureHeartBeat < 3) {
                countFailureHeartBeat = countFailureHeartBeat + 1;
                // console.log("RETRY FAIL HEARTBEAT COUNTER");
                receiveHeartBeat(); //check Time
            }
            else {
                countFailureHeartBeat = 0;
                heartBeatMsgSent = false;
                // console.log("RECONNECT FAIL HEARTBEAT");
                const logData = {
                    lastSocketMsg: lastMsgTime,
                    lastHeartBeat: lastHeartBeatTime,
                    currentTime: Date.now(),
                    HeartBeatSent: HeartBeatSentTime,
                };
                // publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                //   method: "ERROR RECONNECT HEARTBEAT",
                //   reason: { Data: logData },
                // });
                // logHeartBeat('ERROR RECONNECT HEARTBEAT', getDataFromSession(SESSION_KEYS.CLIENT_CODE), logData);
                reconnectSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE));
                //reSubscribeSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
            }
        }
        else {
            // console.log("MSG RECEIVED HEARTBEAT");
            heartBeatMsgSent = false;
        }
    }, 500);
};
